import request from '@/utils/request'
import store from '@/store'
import axios from 'axios'
const url = store.getters.getPostUrl;
export default {
  equipmentPartsPartsDataSituation(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/partsDataSituation',
      method: 'post',
      params:param
    })
  },
  equipmentPartsInOrOutParts(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/inOrOutParts',
      method: 'post',
      params:param
    })
  },
  equipmentPartsAll() {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/all',
      method: 'post',
      data:{}
    })
  },
  equipmentPartsInOrOutAllParts(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/inOrOutAllParts',
      method: 'post',
      params:param
    })
  },
  equipmentPartsUnitPriceSupplier(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/equipmentParts/unitPriceSupplier',
      method: 'post',
      params:param
    })
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/statistics/parts.js